import styled from 'styled-components';
import Button from '../../../../new-components/ui/Button';
import { useTranslation } from 'next-i18next';
import useFilterActions from '../../hooks/FilterActions';

const FilterActions = () => {
  const { t } = useTranslation('common');


  const { applyFilters, resetFilters } = useFilterActions();

  const handleResetFilters = () => {
    resetFilters();
  };

  return (
    <Container>
      <Button
        text={t('apply')}
        backgroundColor="#1E4164"
        color="#fff"
        border="1px solid #006694"
        fontSize="14px"
        onClick={applyFilters}
        btnClass="action-btn"
        containerClass="btn-container"
      />
      <Button
        text={t('reset')}
        backgroundColor="#fff"
        color="#344054"
        border="1px solid #D0D5DD"
        fontSize="14px"
        onClick={handleResetFilters}
        btnClass="action-btn"
        containerClass="btn-container"
      />
    </Container>
  );
};

const Container = styled.div`
  position: sticky;
  width: 100%;
  min-height: 50px;
  display: flex;
  align-items: center;
  gap: 8px;
  bottom: 0;
  background-color: #fff;
  z-index: 99;

  .btn-container {
    width: 100%;
  }

  .action-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-radius: 8px;
    padding: 10px 16px;
    flex: 1 0 0;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

    :disabled {
      background: grey;
      pointer-events: none;
    }
  }
`;

export default FilterActions;
